import { Typography } from '@material-ui/core'
import { TFunction } from 'i18next'
import React from 'react'
import { withTranslation } from 'react-i18next'
import BoardEmpty from '../boardEmpty'

interface BoardEmptyStateProps {
  t: TFunction
  /** Viewer owns this board or folder, so they get onboarding rather than an explanation. */
  canEdit: boolean
  hasUsername: boolean
  /**
   * `privacyRestricted` from the API: the member does have content here, but this viewer isn't
   * being shown it. Only the server can know that — there is no per-item privacy flag on the wire
   * to infer it from — so it is never guessed client-side.
   */
  privacyRestricted?: boolean
}

/**
 * The one place that decides what an empty shopping board or folder says.
 *
 * Three cases in priority order: the owner gets the "add your first product" onboarding, a visitor
 * being denied private content is told that's why it's empty, and anyone looking at a genuinely
 * empty public board gets the plain "no products". Shared by the main board and the folder page so
 * the two can't drift apart.
 */
const BoardEmptyState = ({
  t,
  canEdit,
  hasUsername,
  privacyRestricted = false,
}: BoardEmptyStateProps) => {
  if (canEdit) return <BoardEmpty hasUsername={hasUsername} />

  return (
    <Typography variant="h3">
      {privacyRestricted
        ? t('shoppingBoard.privateCollectionNotice')
        : t('shoppingBoard.noProducts')}
    </Typography>
  )
}

export default withTranslation()(BoardEmptyState)
